module.exports = __webpack_public_path__ + "img/step4-mobile.86474763.jpg";